// extracted by mini-css-extract-plugin
module.exports = {"container":"Expectations_container__7P17K","expectations":"Expectations_expectations__39i30","expectation":"Expectations_expectation__pAspu","cta":"Expectations_cta__sw3yP"};